export default __webpack_public_path__ + "static/media/3t.a3a95918.jpg";